<template>

    <div>

        <div class="row row-cols-1 row-cols-lg-2 g-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <select-input label="country" v-model="form.country_id" :error="form.errors.country_id">
                                <option :value="country.id" v-for="country in countries">{{ country.name }}</option>
                            </select-input>
                            <text-input label="company" v-model="form.company" :error="form.errors.company" />
                            <text-input label="salutation" v-model="form.salutation" :error="form.errors.salutation" />
                            <text-input label="title" v-model="form.title" :error="form.errors.title" />
                            <text-input label="first_name" v-model="form.first_name" :error="form.errors.first_name" />
                            <text-input label="last_name" v-model="form.last_name" :error="form.errors.last_name" />
                            <div class="row">
                                <div class="col-8">
                                    <text-input label="street" v-model="form.street" :error="form.errors.street" />
                                </div>
                                <div class="col-4">
                                    <text-input label="house_number" v-model="form.house_number" :error="form.errors.house_number" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <text-input label="zip_code" v-model="form.zip_code" :error="form.errors.zip_code" />
                                </div>
                                <div class="col-sm-8">
                                    <text-input label="city" v-model="form.city" :error="form.errors.city" />
                                </div>
                            </div>
                            <text-input label="county" v-model="form.county" :error="form.errors.county" />
                            <text-input label="phone" v-model="form.phone" type="tel" :error="form.errors.phone" />
                            <textarea-input label="notes" v-model="form.notes" :error="form.errors.notes" />
                            <checkbox-input label="als Standard Rechnungsadresse festlegen" v-model="form.default_billing_address" :error="form.errors.default_billing_address" />
                            <checkbox-input label="als Standard Lieferadresse festlegen" v-model="form.default_delivery_address" :error="form.errors.default_delivery_address" />
                        </fieldset>

                    </div>

                </div>
            </div>

            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
                <button type="button" class="btn link-danger" @click="destroy" v-if="address">
                    {{ __('Löschen') }}
                </button>
            </div>

        </div>

    </div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import PriceInput from '@/shared/Inputs/PriceInput';
    import PercentInput from '@/shared/Inputs/PercentInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'form',
            'address',
            'countries',
        ],
        data() {
            return {
            }
        },
        components: {
            TextInput,
            PriceInput,
            PercentInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
        },
        watch: {
        },
        methods: {
            addOption() {

                if (this.form.options.length >= 100) {
                    alert('Sie können maximal 100 Optionen angeben.');
                    return false;
                }

                const option = {
                };
                this.form.options.push(option);
            },
            cloneOption(index) {
                if (this.form.options.length >= 100) {
                    alert('Sie können maximal 100 Optionen angeben.');
                    return false;
                }

                let cloned = JSON.parse(JSON.stringify(this.form.options[index]));
                this.form.options.push(cloned);
            },
            removeOption(index) {
                Vue.delete(this.form.options, index);
            },
            destroy() {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('admin.addresses.destroy', this.address));
                }
            },
        },
    }
</script>
